import MetaModel from "../../../../Global/Models/Pagination/MetaModel";
import PollBasicModel from "./PollBasicModel";

export default class PollsModel {
  public meta: MetaModel = new MetaModel();
  public data: PollBasicModel[] = [];
}
